/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskEvaluationRequest } from './taskEvaluationRequest';

export type ModuleEvaluationRequestTaskEvaluationsAnyOf = { [key: string]: TaskEvaluationRequest };
